import AjaxUtil from '../../../common/Js/AjaxHelper/AjaxUtil';

import { ApiEndPoints } from '../../../common/ApiHelper/ApiUrls';
import { GetAuthTokenHeader } from '../../../common/Js/AjaxHelper/Helpers';

export default class api {
  static hasEditSettingsPermissions() {
    const url = ApiEndPoints.Settings.HasEditSettingsPermissions;
    return AjaxUtil.sendGet(url);
  }

  static getScanGroupDetails(groupId) {
    const url = ApiEndPoints.Settings.GetScanGroupDetails + '?groupId=' + groupId;
    return AjaxUtil.sendGet(url);
  }

  static getScanGroups() {
    const url = ApiEndPoints.Settings.GetScanGroups;
    return AjaxUtil.sendGet(url);
  }

  static getScanAccounts() {
    const url = ApiEndPoints.Settings.GetScanAccounts;
    return AjaxUtil.sendGet(url);
  }

  static saveGroupInformation(groupId, groupInformation) {
    let url = ApiEndPoints.Settings.SaveGroupInformation;
    let body = { groupId: groupId, groupInformation: groupInformation };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static deleteGroup(groupId) {
    let url = ApiEndPoints.Settings.DeleteGroup;
    let body = { groupId: groupId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static deleteAccont(groupId, accountName) {
    let url = ApiEndPoints.Settings.RemoveAccount;
    let body = { agentName: accountName, groupId: groupId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static addGroup(scanGroup) {
    let url = ApiEndPoints.Settings.AddGroup;
    let body = { scanGroup: scanGroup };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static addAccount(groupId, accountInformation) {
    let url = ApiEndPoints.Settings.AddAccount;
    let body = { groupId: groupId, accountInformation: accountInformation };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static updateAccount(groupId, accountInformation) {
    let url = ApiEndPoints.Settings.UpdateAccount;
    let body = { groupId: groupId, accountInformation: accountInformation };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static getScanAccount(accountName) {
    let url = ApiEndPoints.Settings.GetScanAccount;
    let body = { accountName: accountName };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static validateCredentials(accountInformation) {
    let url = ApiEndPoints.Settings.ValidateCredentials;
    let body = { accountInformation: accountInformation };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static generateServiceEncryptionToken() {
    let url = ApiEndPoints.Settings.GenerateHostGroupAccountTokenKey;
    return AjaxUtil.genericSendPost(url, {});
  }

  static updateServiceEncryptionToken(tokenKey) {
    let url = ApiEndPoints.Settings.SetHostGroupAccountTokenKey;
    let body = { tokenKey: tokenKey };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static deleteScanPopulation(groupId, scannedEndpointType, hosts) {
    let url = ApiEndPoints.Settings.DeleteScannedEndpoint;
    let body = { groupId: groupId, scannedEndpointType: scannedEndpointType, hosts };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static addScanPopulation(groupId, scannedEndpointType, item) {
    let url = ApiEndPoints.Settings.AddScannedEndpoint;
    let body = { groupId: groupId, scannedEndpointType: scannedEndpointType, item: item };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static getHostPopulation(groupId) {
    let url = ApiEndPoints.Settings.GetHostsPopulation;
    url += '?groupId=' + groupId;
    return AjaxUtil.sendGet(url);
  }

  static deleteGroupScheduling(groupSchedulingIds) {
    let url = ApiEndPoints.Settings.DeleteGroupScheduling;
    let body = { groupSchedulingIds: groupSchedulingIds };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static addGroupScheduling(groupScheduling) {
    let url = ApiEndPoints.Settings.AddGroupScheduling;
    let body = { groupScheduling: groupScheduling };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static updateGroupScheduling(groupScheduling) {
    let url = ApiEndPoints.Settings.UpdateGroupScheduling;
    let body = { groupScheduling: groupScheduling };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static syncAD(groupId, initiateNewSync) {
    let url = ApiEndPoints.Settings.SyncAD;
    url += '?groupId=' + groupId + '&initiateNewSync=' + initiateNewSync;
    return AjaxUtil.sendGet(url);
  }

  //system info
  static getSystemInfo() {
    let url = ApiEndPoints.Settings.GetSystemInfo;
    return AjaxUtil.sendGet(url);
  }

  //alerts
  static getAlertsSettings() {
    const url = ApiEndPoints.Settings.GetAlertsSettings;
    const urlExternalEmailsList = ApiEndPoints.Settings.GetExternalDistributionEmailsList;

    return Promise.allSettled([AjaxUtil.sendGet(url), AjaxUtil.sendGet(urlExternalEmailsList)]);
  }

  static saveAlertsSettings(settingsAlertsDTO) {
    let url = ApiEndPoints.Settings.SaveAlertsSettings;
    let urlExternalEmailsList = ApiEndPoints.Settings.UpdateExternalDistributionEmailsList;

    const { externalEmailsList = {}, ...rest } = settingsAlertsDTO;
    let body = { settingsAlertsDTO: rest };

    const { EmailList, IsSucceed } = externalEmailsList;

    const saveExternalEmailsListRequest = () =>
      IsSucceed ? AjaxUtil.genericSendPost(urlExternalEmailsList, JSON.stringify(EmailList)) : Promise.resolve();

    return Promise.all([AjaxUtil.genericSendPost(url, JSON.stringify(body)), saveExternalEmailsListRequest()]);
  }
  static getHostsByKey(keyWord) {
    let url = ApiEndPoints.Settings.GetHostsByKey;
    url += '?keyWord=' + keyWord;
    return AjaxUtil.sendGet(url);
  }

  static removeHostFromAutoScanAlert(hostIds) {
    let url = ApiEndPoints.Settings.RemoveHostFromAutoScanAlert;
    let body = { hostIds: hostIds };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static addHostToAutoScanAlert(hostId) {
    let url = ApiEndPoints.Settings.AddHostToAutoScanAlert;
    let body = { hostId: hostId };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  //analysis
  static getAnalysisSettings() {
    let url = ApiEndPoints.Settings.GetAnalysisSettings;
    return AjaxUtil.sendGet(url);
  }

  static saveAnalysisSettings(settingsAnalysisDTO) {
    let url = ApiEndPoints.Settings.SaveAnalysisSettings;
    let body = { settingsAnalysisDTO: settingsAnalysisDTO };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static upload2ServerCsvFile(data) {
    let url = ApiEndPoints.Settings.ImportGroupHosts;

    let body = data;
    let headers = GetAuthTokenHeader();
    return AjaxUtil.genericSendPost(url, body, headers);
  }
  static ExportGroupHosts(groupId) {
    let url = ApiEndPoints.Settings.ExportGroupHosts;
    let body = { groupId: groupId };
    return AjaxUtil.postDownloadFile(url, JSON.stringify(body));
  }

  static getExternalIntegration() {
    let url = ApiEndPoints.Settings.GetExternalIntegration;
    return AjaxUtil.sendGet(url);
  }

  static saveExternalSettings(data) {
    let url = ApiEndPoints.Settings.SaveExternalSettings;
    let body = data;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static getExternalSettings(tenantId, scanGroupId, integrationType) {
    let url =
      ApiEndPoints.Settings.GetExternalSettings +
      '?tenantId=' +
      tenantId +
      '&scanGroupId=' +
      scanGroupId +
      '&IntegrationType=' +
      integrationType;
    return AjaxUtil.sendGet(url);
  }
  static connectivityTest(data) {
    let url = ApiEndPoints.Settings.ConnectivityTest;
    let body = data;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static billingConnectivityTest(data) {
    const url = ApiEndPoints.Settings.BillingConnectivityTest;
    const body = data;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static connectivityTestByKey(data) {
    let url = ApiEndPoints.Settings.ConnectivityTestByKey;
    let body = data;
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  static setExternalIntegrationEnabled(tenantId, scanGroupId, integrationType, isEnabled) {
    let url =
      ApiEndPoints.Settings.SetExternalIntegrationEnabled +
      '?tenantId=' +
      tenantId +
      '&scanGroupId=' +
      scanGroupId +
      '&integrationType=' +
      integrationType +
      '&isEnabled=' +
      isEnabled;
    return AjaxUtil.genericSendPost(url);
  }

  static getExternalIntegrationEnabled(tenantId, scanGroupId, integrationType) {
    let url =
      ApiEndPoints.Settings.GetExternalIntegrationEnabled +
      '?tenantId=' +
      tenantId +
      '&scanGroupId=' +
      scanGroupId +
      '&integrationType=' +
      integrationType;
    return AjaxUtil.sendGet(url);
  }
}
